export default __webpack_public_path__ + "static/media/_A6A9889.381dd5af.jpg";